import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const state = {
  sales: [],
  sale: {
    attachments: [],
    tracings: []
  },
  salesDetail: {},
  invoices: [],
  receptionsDetails: [],
  sentsDetails: [],
  invoicePayments: [],
  amount: {},
  salesSupplier: {},
  amountPayment: {},
  receptions: {},
  paymentsSales: [],
  supplier: [],
  quantitys: [],
  sendreceptionsDetails: {},
  allSendreceptionsDetails: {},
  purchaseOrders: [],
  imports: [],
  expenses: [],
  paginationsSendreceptionsDetails: {
    currentPage: 1,
    perPage: 5,
    totalPurchaseOrders: 0,
    totalPages: 0
  },
  paginationInvoice: {
    currentPage: 1,
    perPage: 5,
    totalPurchaseOrders: 0,
    totalPages: 0
  },
  paginationPaymentInvoice: {
    currentPage: 1,
    perPage: 5,
    totalPurchaseOrders: 0,
    totalPages: 0
  },
  paginationsReceptions: {
    currentPage: 1,
    perPage: 5,
    totalSales: 0,
    totalPages: 0
  },
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalSales: 0,
    totalPages: 0
  },
  salesCatalog: {
    customers: [],
    currencies: [],
    quotations: [],
    users: [],
    payment_methods: [],
    purchase_orders: []
  },
  registry: [],
  filterParams: '',
  isModalVisible: false,
  isModalInvoiceNumberVisible: false,
  isModalPaymentDateVisible: false,
  isModalAttachmentVisible: false,
  isModalPackingVisible: false,
  isModalTagVisible: false,
  isModalSendrecepVisible: false,
  isModalSalesRecepVisible: false,
  isModalSalesSuppliershipmentVisible: false,
  isModalTracingsVisible: false,
  isModalCustomerSalesVisible: false
}

const mutations = {
  UPDATE_SALE (state, payload) {
    const idx = state.sales.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.sales, idx, payload)
    }
  },
  INVOICE_SHOW (state, payload) {
    state.invoices = payload.data
    state.paginationInvoice = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      total: payload.total,
      totalPages: payload.last_page
    }
  },
  INVOICE_PAYMENTS_SHOW (state, payload) {
    state.invoicePayments = payload.data
    state.paginationPaymentInvoice = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      total: payload.total,
      totalPages: payload.last_page
    }
  },
  RECEPTIONS_SHOW (state, payload) {
    state.receptions = payload.data
    state.paginationsReceptions = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      total: payload.total,
      totalPages: payload.last_page
    }
  },
  SENDRECEPTIONS_DETAILS_SHOW (state, payload) {
    state.sendreceptionsDetails = payload
  },
  SET_PAYMENTS_SALE (state, payload) {
    state.paymentsSales = payload
  },
  GET_AMOUNT (state, payload) {
    state.amount = payload
  },
  GET_SALES_SUPPLIER (state, payload) {
    state.salesSupplier = payload
  },
  GET_AMOUNT_PAYMENTS (state, payload) {
    state.amountPayment = payload
  },
  ADD_INVOICE (state, payload) {
    state.invoices.unshift(payload)
  },
  ADD_INVOICE_PAYMENT (state, payload) {
    state.invoices.unshift(payload)
  },
  SET_SALES (state, payload) {
    state.sales = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalSales: payload.total,
      totalPages: payload.last_page
    }
  },
  ADD_SALE (state, payload) {
    state.sales.unshift(payload)
  },
  UPPAYMENT_DATE (state, payload) {
    const idx = state.sales.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.sales, idx, payload)
    }
  },
  DELETE_INVOICE (state, payload) {
    const idx = state.invoices.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.invoices, idx)
    }
  },
  DELETE_INVOICE_PAYMENT (state, payload) {
    const idx = state.invoicePayments.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.invoicePayments, idx)
    }
  },
  DELETE_SALE (state, payload) {
    const idx = state.sales.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.sales, idx)
    }
  },
  DELETE_SALES (state, payload) {
    for (let id of payload.ids) {
      const idx = state.sales.findIndex(u => u.id === id)

      if (idx >= 0) {
        Vue.delete(state.sales, idx)
      }
    }
  },
  UPDATE_INVOICE (state, payload, idx) {
    if (idx >= 0) {
      Vue.set(state.invoices, idx, payload)
    }
  },
  ADD_ATTACHMENT (state, payload) {
    state.sale.attachments.unshift(payload)
  },
  SET_SALE (state, payload) {
    state.sale = payload.data
  },
  SET_OC_RECEPTIONS (state, payload) {
    state.receptions = payload
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_RECEPTIONS_DETAILS (state, payload) {
    state.receptionsDetails = payload
  },
  SET_SENTS_DETAILS (state, payload) {
    state.sentsDetails = payload
  },
  SET_MODAL_INVOICE_NUMBER_VISIBLE (state, payload) {
    state.isModalInvoiceNumberVisible = payload
  },
  SET_MODAL_PAYMENT_DATE_VISIBLE (state, payload) {
    state.isModalPaymentDateVisible = payload
  },
  SET_MODAL_ATTACHMENT (state, payload) {
    state.isModalAttachmentVisible = payload
  },
  SET_MODAL_PACKING_VISIBLE (state, payload) {
    state.isModalPackingVisible = payload
  },
  SET_MODAL_TAG_VISIBLE (state, payload) {
    state.isModalTagVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.salesCatalog[object] = payload.data
  },
  SET_PAYMENT_RECORD (state, payload) {
    state.invoicePayments.unshift(payload)
  },
  SET_SALE_DETAIL (state, payload) {
    state.salesDetail = payload
  },
  SET_MODAL_SALES_RECEP_VISIBLE (state, payload) {
    state.isModalSalesRecepVisible = payload
  },
  SET_MODAL_SALES_SUPPLIERSHIP_VISIBLE (state, payload) {
    state.isModalSalesSuppliershipmentVisible = payload
  },
  SET_SENDRECEPTIONS (state, payload) {
    state.sendreceptionsDetails.unshift(payload)
  },
  SET_ALLSENDRECEPTIONS (state, payload) {
    state.allSendreceptionsDetails = payload
  },
  GET_QUANTITYS (state, payload) {
    state.quantitys = payload
  },
  SET_SUPPLIER (state, payload) {
    state.supplier = payload
  },
  SET_PURCHASE_ORDERS (state, payload) {
    state.purchaseOrders = payload
  },
  SET_IMPORTS (state, payload) {
    state.imports = payload
  },
  SET_EXPENSES (state, payload) {
    state.expenses = payload
  },
  SET_MODAL_TRACINGS_VISIBLE (state, payload) {
    state.isModalTracingsVisible = payload
  },
  SET_SALE_REGISTRY (state, payload) {
    state.registry = payload
  },
  SET_MODAL_CUSTOMER_SALES_VISIBLE (state, payload) {
    state.isModalCustomerSalesVisible = payload
  },
  UPDATE_SALE_TRACINGS (state, payload) {
    const idx = state.sale.tracings.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.sale.tracings, idx, payload)
    }
  }
}

const actions = {
  async loadSales ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sales?page=${payload.page}${state.filterParams}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SALES', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadInvoice ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`invoice?page=${payload.page}&param=${payload.sales_id},sales_id`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sales.invoiced', text: checkErrors.message }, { root: true })
      } else {
        commit('INVOICE_SHOW', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadInvoicesPayments ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`invoice-payments?page=${payload.page}&param=${payload.id},invoice_id`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sales.invoice', text: checkErrors.message }, { root: true })
      } else {
        commit('INVOICE_PAYMENTS_SHOW', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadSendReceptionsDetails ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`salessendreceptions/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'purcharse_orders_details.receptions', text: checkErrors.message }, { root: true })
      } else {
        commit('SENDRECEPTIONS_DETAILS_SHOW', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addInvoicesPayment ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`invoice-payments`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sales.invoice', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.payment', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        commit('SET_PAYMENT_RECORD', response.data.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadAmount ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`/invoice/amount/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.invoiced', text: checkErrors.message }, { root: true })
      } else {
        commit('GET_AMOUNT', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadAmountPayment ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`/invoice-payments/amount/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.invoiced', text: checkErrors.message }, { root: true })
      } else {
        commit('GET_AMOUNT_PAYMENTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addSale ({ commit }, payload) {
    const sale = {
      folio: payload.folio,
      delivery_time: payload.delivery_time,
      total: parseFloat(payload.total),
      exchange_rate: parseFloat(payload.exchange_rate),
      status: payload.status,
      customer_id: payload.customer_id,
      currency_id: payload.currency_id,
      seller_id: payload.seller_id,
      quotation_id: payload.quotation_id,
      payment_method_id: payload.payment_method_id
    }

    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.post('sales', sale)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_SALE', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.sales', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async editSale ({ commit }, payload) {
    const sale = {
      folio: payload.folio,
      delivery_time: payload.delivery_time,
      total: parseFloat(payload.total),
      exchange_rate: parseFloat(payload.exchange_rate),
      comments: payload.comments,
      status: payload.status,
      customer_id: payload.customer_id,
      currency_id: payload.currency_id,
      created_by_id: payload.created_by_id,
      quotation_id: payload.quotation_id,
      payment_method_id: payload.payment_method_id
    }

    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.put(`sales/${payload.id}`, sale)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_SALE', response.data)
        commit('UPPAYMENT_DATE', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.sales', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_MODAL_VISIBLE', false)
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addAttachment ({ commit }, payload) {
    let formData = new FormData()
    formData.append('attachment', payload.file)
    formData.append('sale_id', payload.sale_id)
    formData.append('description', payload.description)

    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.post(`attachments`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_ATTACHMENT', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.attachments', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async download ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(`${Vue.axios.defaults.baseURL}/attachments/${payload.id}/download`)
    } catch (error) {
      app.$Progress.fail()
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteSale ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`sales/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_SALE', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.sales', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteSales ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`sales/delete`, { params: { ids: payload.ids } })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_SALES', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.sales', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteInvoice ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`invoice/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_INVOICE', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'sales.invoice', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteInvoicePayment ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`invoice-payments/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_INVOICE_PAYMENT', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'sales.payment', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadSale ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sales/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.sales', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SALE', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async actionSale ({ commit }, payload) {
    let props = ''
    payload.props && (props = payload.props)
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`sales/${payload.id}/${payload.action}${props}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPPAYMENT_DATE', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_MODAL_PAYMENT_DATE_VISIBLE', false)
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(axios.defaults.baseURL + '/sales/export?order_by=currency_id,asc' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  printInvoices ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(axios.defaults.baseURL + '/invoices/export')
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  printReportCsv ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(axios.defaults.baseURL + '/sales/export?format=csv&&order_by=currency_id,asc' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadSaleInformation ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sales/${payload.sale_id}/information`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SALE', response)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  printPackingList ({ commit }, payload) {
    let address = payload.form.address ? payload.form.address : ''
    let comments = payload.form.comments ? payload.form.comments : ''
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(`${axios.defaults.baseURL}/sales/${payload.id}/packing?attention=${payload.form.attention}&address=${address}&service=${payload.form.service}&tracking=${payload.form.tracking}&comments=${comments}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_MODAL_PACKING_VISIBLE', false)
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  printTag ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(`${axios.defaults.baseURL}/sales/${payload.id}/tag?attention=${payload.form.attention}&address_id=${payload.form.customer_address_id}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_MODAL_TAG_VISIBLE', false)
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addInvoice ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post('invoice', payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        if (response.data.type === 'create') {
          commit('ADD_INVOICE', response.data.data)
          commit('SET_ACCEPT_ALERT', { color: 'success', title: 'sales.invoice', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        } else if (response.data.type === 'update') {
          commit('UPDATE_INVOICE', response.data.data)
        }
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addInvoicePayment ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post('invoicesPayment', payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        if (response.data.type === 'create') {
          commit('ADD_INVOICE_PAYMENT', response.data.data)
          commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.invoices', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        } else if (response.data.type === 'update') {
          commit('UPDATE_INVOICE', response.data.data)
        }
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadQuotation ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`quotations/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('Quotations/INIT_QUOTATION_DETAIL', response.data.data, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadPaymentSales ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`/sales-detail/invoice/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PAYMENTS_SALE', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadPaymentsAll ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`/sales-detail/invoice/`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PAYMENTS_SALE', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadPurchaseOrders ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sales/${payload.sale_id}/orders`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PURCHASE_ORDERS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadImports ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sales/${payload.sale_id}/imports`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_IMPORTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadExpenses ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sales/${payload.sale_id}/expenses`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_EXPENSES', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addImport ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`sales/${payload.sale_id}/imports`, payload.data)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_IMPORTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addExpense ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`sales/${payload.sale_id}/expenses`, payload.data)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_EXPENSES', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteImport ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`sales/${payload.sale_id}/imports/${payload.import}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.sale-imports', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteExpense ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`sales/${payload.sale_id}/expenses/${payload.expense}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.sale-expenses', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addSaleTracing ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.post('sale-tracings', payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPPAYMENT_DATE', response.data)
        commit('SET_MODAL_TRACINGS_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.sale_tracings', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadSaleRegistry ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sales/${payload.sale_id}/registry`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SALE_REGISTRY', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteAttachment ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`attachments/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.attachments', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  setPaymentsInvoice ({ commit }, payload) {
    commit('SET_PAYMENTS_SALE', payload)
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setModalInvoicesVisible ({ commit }, payload) {
    commit('Invoices/SET_MODAL_VISIBLE', payload, { root: true })
  },
  setModalPaymentDateVisible ({ commit }, payload) {
    commit('SET_MODAL_PAYMENT_DATE_VISIBLE', payload)
  },
  setModalImportVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_VISIBLE', payload, { root: true })
  },
  setModalAttachmentVisible ({ commit }, payload) {
    commit('SET_MODAL_ATTACHMENT', payload)
  },
  setModalCommentsVisible ({ commit }, payload) {
    commit('SET_MODAL_COMMENTS_VISIBLE', payload, { root: true })
  },
  setModalPackingVisible ({ commit }, payload) {
    commit('SET_MODAL_PACKING_VISIBLE', payload)
  },
  setModalTagVisible ({ commit }, payload) {
    commit('SET_MODAL_TAG_VISIBLE', payload)
  },
  setModalSendingReceptionsVisible ({ commit }, payload) {
    commit('SendingReceptionInformation/SET_MODAL_VISIBLE', payload, { root: true })
  },
  setModalSalesReceptios ({ commit }, payload) {
    commit('SET_MODAL_SALES_RECEP_VISIBLE', payload)
  },
  setModalSalesSuppliershipment ({ commit }, payload) {
    commit('SET_MODAL_SALES_SUPPLIERSHIP_VISIBLE', payload)
  },
  setSupplierOc ({ commit }, payload) {
    commit('SET_SUPPLIER', payload)
  },
  setModalTracingsVisible ({ commit }, payload) {
    commit('SET_MODAL_TRACINGS_VISIBLE', payload)
  },
  setModalCustomerSalesVisible ({ commit }, payload) {
    commit('SET_MODAL_CUSTOMER_SALES_VISIBLE', payload)
  },
  printCustomerSales ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(axios.defaults.baseURL + `/sales/export-customer?format=${payload.form.format}&&order_by=currency_id,asc&&customer_id=${payload.form.customer_id}`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_MODAL_TAG_VISIBLE', false)
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async setAttended ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`sale-tracings/${payload}/attended`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_SALE_TRACINGS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  }
}

const getters = {
  sales: state => state.sales,
  sale: state => state.sale,
  salesCatalog: state => state.salesCatalog,
  quantitys: state => state.quantitys,
  pagination: state => state.pagination,
  isModalVisible: state => state.isModalVisible,
  isModalInvoiceNumberVisible: state => state.isModalInvoiceNumberVisible,
  isModalPaymentDateVisible: state => state.isModalPaymentDateVisible,
  isModalAttachmentVisible: state => state.isModalAttachmentVisible,
  isModalSendrecepVisible: state => state.isModalSendrecepVisible,
  isModalSalesSuppliershipmentVisible: state => state.isModalSalesSuppliershipmentVisible,
  isModalSalesRecepVisible: state => state.isModalSalesRecepVisible,
  isModalPackingVisible: state => state.isModalPackingVisible,
  isModalTagVisible: state => state.isModalTagVisible,
  isModalTracingsVisible: state => state.isModalTracingsVisible,
  isModalCustomerSalesVisible: state => state.isModalCustomerSalesVisible,
  filterParams: state => state.filterParams,
  receptionsDetails: state => state.receptionsDetails,
  sentsDetails: state => state.sentsDetails,
  invoices: state => state.invoices,
  invoicePayments: state => state.invoicePayments,
  paginationInvoice: state => state.paginationInvoice,
  paginationsReceptions: state => state.paginationsReceptions,
  paginationsSendreceptionsDetails: state => state.paginationsSendreceptionsDetails,
  amount: state => state.amount,
  salesSupplier: state => state.salesSupplier,
  amountPayment: state => state.amountPayment,
  salesDetail: state => state.salesDetail,
  paymentsSales: state => state.paymentsSales,
  quotation: (state, getters, rootState, rootGetters) => rootGetters['Quotations/quotation'],
  supplier: state => state.supplier,
  purchaseOrders: state => state.purchaseOrders,
  imports: state => state.imports,
  expenses: state => state.expenses,
  registry: state => state.registry
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
